<div class="ticketScannerContainer">
  <div class="top-selector">
    <div class="iconItem">
      <p class="headline">Scan your ticket!</p>
      <div class="scanner-image-container">
        <image-loader-utils url="scanner-barcode" extraClasses="icon-svg"></image-loader-utils>
      </div>
    </div>
    <div class="iconItem">
      <p class="headline">Login via QR code</p>
      <div class="scanner-image-container">
        <image-loader-utils url="scanner-qr" extraClasses="icon-svg"></image-loader-utils>
      </div>
    </div>
  </div>
  <div class="scannerMain">
    <div class="scannerOverlay">
      <div class="scannerColumn backdrop"></div>
      <div class="scannerColumn four">
        <div class="scannerRow backdrop"></div>
        <div class="scannerRow three"></div>
        <div class="scannerRow backdrop textMain">
          <p>
            {{ scanMessage }}
          </p>
        </div>
      </div>
      <div class="scannerColumn backdrop"></div>
    </div>
    <zxing-scanner
      [torch]="torchEnabled"
      [(device)]="currentDevice"
      (scanSuccess)="onCodeResult($event)"
      [formats]="formatsEnabled"
      [tryHarder]="tryHarder"
      (permissionResponse)="onHasPermission($event)"
      (camerasFound)="onCamerasFound($event)"
      (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>
  </div>
  <div class="scanResult">
    <select (change)="onDeviceSelectChange($event.target.value)">
      <option value="" [selected]="!currentDevice">No Device Selected</option>
      <option *ngFor="let device of availableDevices" [value]="device.deviceId" [selected]="currentDevice && device.deviceId === currentDevice.deviceId">
        {{ device.label }}
      </option>
    </select>
  </div>
</div>
